module.exports = __webpack_public_path__ + "img/swiper-21.1665736a.png";